var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.saveVehicle.apply(null, arguments)
          }
        }
      },
      [
        _c("div", [
          _c("label", { attrs: { for: "description" } }, [_vm._v("Make")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingVehicle.make,
                expression: "editingVehicle.make"
              }
            ],
            attrs: { name: "description", type: "text", placeholder: "make" },
            domProps: { value: _vm.editingVehicle.make },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.editingVehicle, "make", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("label", { attrs: { for: "model" } }, [_vm._v("Model")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingVehicle.model,
                expression: "editingVehicle.model"
              }
            ],
            attrs: { name: "model", type: "text", placeholder: "model" },
            domProps: { value: _vm.editingVehicle.model },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.editingVehicle, "model", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("label", { attrs: { for: "year" } }, [_vm._v("Year")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingVehicle.year,
                expression: "editingVehicle.year"
              }
            ],
            attrs: { name: "year", type: "text", placeholder: "year" },
            domProps: { value: _vm.editingVehicle.year },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.editingVehicle, "year", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("label", { attrs: { for: "mileage" } }, [_vm._v("Mileage")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingVehicle.mileage,
                expression: "editingVehicle.mileage"
              }
            ],
            attrs: { name: "mileage", type: "text", placeholder: "mileage" },
            domProps: { value: _vm.editingVehicle.mileage },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.editingVehicle, "mileage", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("label", { attrs: { for: "description" } }, [
            _vm._v("Description")
          ]),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editingVehicle.description,
                expression: "editingVehicle.description"
              }
            ],
            attrs: { name: "description", placeholder: "Description" },
            domProps: { value: _vm.editingVehicle.description },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.editingVehicle, "description", $event.target.value)
              }
            }
          })
        ]),
        _c("input", { attrs: { type: "submit" } })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }